export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="border-t border-ink/10 bg-[#efe6d6]">
      <div className="shell-wrap py-12">
        <div className="grid gap-8 md:grid-cols-[1.4fr_1fr_1fr_1fr]">
          {/* brand */}
          <div>
            <a href="#top" className="flex items-center gap-2.5 cursor-pointer">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-ember text-lg font-black text-white">
                91
              </span>
              <span className="title-serif text-xl font-black">黑料</span>
            </a>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-ink/60">
              91黑料 持续整理人物、事件、时间线档案与专题合集，热门瓜料与冷门旧闻集中呈现，
              方便快速查阅与交叉比对。本站为静态浏览页，内容仅供信息归纳使用。
            </p>
            <p className="mt-4 inline-flex items-center gap-2 rounded-full border border-ink/15 px-3 py-1.5 text-xs text-ink/55">
              <i className="ri-time-line text-ember" /> 合集与大全 · 持续更新中
            </p>
          </div>

          {/* 查阅 */}
          <div>
            <h3 className="text-sm font-black text-ink">查阅入口</h3>
            <ul className="mt-4 space-y-2.5 text-sm text-ink/60">
              <li><a href="#collections" className="transition-colors hover:text-ember">合集大全</a></li>
              <li><a href="#catalog" className="transition-colors hover:text-ember">分类导览</a></li>
              <li><a href="#archives" className="transition-colors hover:text-ember">人物档案</a></li>
              <li><a href="#timeline" className="transition-colors hover:text-ember">时间线整理</a></li>
            </ul>
          </div>

          {/* 专题 */}
          <div>
            <h3 className="text-sm font-black text-ink">专题整理</h3>
            <ul className="mt-4 space-y-2.5 text-sm text-ink/60">
              <li><a href="#specials" className="transition-colors hover:text-ember">专题研究</a></li>
              <li><a href="#oldnews" className="transition-colors hover:text-ember">冷门旧闻考古</a></li>
              <li><a href="#trending" className="transition-colors hover:text-ember">今日话题墙</a></li>
            </ul>
          </div>

          {/* 说明 */}
          <div>
            <h3 className="text-sm font-black text-ink">浏览说明</h3>
            <ul className="mt-4 space-y-2.5 text-sm text-ink/60">
              <li><a href="#faq" className="transition-colors hover:text-ember">常见问题</a></li>
              <li className="text-ink/45">信息口径：公开声明 / 报道 / 考古</li>
              <li className="text-ink/45">转载需保留原始出处</li>
            </ul>
          </div>
        </div>

        <div className="mt-10 flex flex-col gap-3 border-t border-ink/10 pt-6 text-xs text-ink/45 sm:flex-row sm:items-center sm:justify-between">
          <p>© {year} 91黑料 · 合集大全 档案列表 专题整理一页看全</p>
          <p className="flex flex-wrap gap-3">
            <span>内容仅供浏览归纳</span>
            <span>信息以各原始媒体口径为准</span>
          </p>
        </div>
      </div>
    </footer>
  );
}